// eslint-disable-next-line max-len,no-useless-escape
export const multiEmailPattern = /^$|^(((([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))+@)((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))(\s*|([,;])\s*|\s*$))*$/i;

export const multiEmailSplitter = /\s*(?:[,;\s]|$)\s*/;

export const onlyNumbersPattern = /^\d+$/;

// eslint-disable-next-line max-len,no-useless-escape
export const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
